import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal } from "@/components/Reveal";

const FAQ = [
  ["Êtes-vous une agence de voyage ou un site de réservation ?",
    "Non. Altitude Club n'est ni une agence de voyage, ni un comparateur de vols, ni un site de réservation. Nous sommes un service d'alertes de vols en classe Business. Nous surveillons les tarifs et vous envoyons un e-mail lorsque nous repérons une offre intéressante au départ de Paris-Charles de Gaulle (CDG). Vous réservez ensuite vous-même, directement auprès du vendeur."],
  ["Pourquoi m'inscrire si je n'ai pas de voyage prévu ?",
    "Pas besoin d'avoir une destination en tête pour profiter du club. Les meilleures offres arrivent sans prévenir : les membres qui économisent le plus sont souvent ceux qui sont déjà inscrits et prêts à saisir la bonne occasion."],
  ["Puis-je essayer Altitude Club gratuitement ?",
    "Oui. Chaque nouveau membre commence par 7 jours d'essai gratuit. Pendant l'essai, vous recevez exactement les mêmes offres que les membres abonnés. Aucun prélèvement avant la fin de l'essai, et vous pouvez résilier à tout moment."],
  ["Et si je n'économise pas d'argent avec le club ?",
    <>Nous le garantissons : si vous n'économisez pas au moins 500 € sur vos vols pendant votre première année d'abonnement, nous vous remboursons votre abonnement. <Link to="/garantie" data-testid="faq-guarantee-link" className="underline decoration-gold-deep underline-offset-2 hover:text-navy">Voir les conditions de la garantie</Link>.</>],
  ["Quelles offres vais-je recevoir ?",
    "Des vols aller-retour en classe Business au départ de Paris-CDG, lorsque le prix est nettement inférieur à son niveau habituel. Chaque offre indique les dates disponibles, la compagnie, les escales, la durée et les informations sur la cabine."],
  ["Combien d'offres vais-je recevoir chaque semaine ?",
    "Vous recevez 2 à 3 offres par semaine au départ de Paris-CDG, uniquement lorsque nous trouvons de vraies bonnes offres. Chaque offre propose plusieurs combinaisons de dates, pour vous laisser de la souplesse dans l'organisation de votre voyage."],
  ["Puis-je choisir une destination précise ?",
    "Pas exactement, mais vous pouvez indiquer votre destination de rêve lors de l'inscription. Nous surveillons de nombreuses destinations long-courriers et vous prévenons dès qu'un tarif Business baisse nettement au départ de Paris-CDG."],
  ["Quelles compagnies aériennes sont concernées ?",
    "Toutes. Ce qui compte pour nous, c'est l'économie et le confort : nous privilégions les cabines Business avec siège-lit plat et accès direct au couloir sur les vols long-courriers."],
  ["Comment réserver un vol après avoir reçu une offre ?",
    "Chaque e-mail contient les détails de l'offre, les dates possibles et un lien pour réserver. Vous réservez directement auprès de la compagnie ou de l'agence en ligne : vous gardez le contrôle de bout en bout."],
  ["Combien de temps les offres restent-elles disponibles ?",
    "Cela varie : certaines offres restent disponibles plusieurs jours, d'autres disparaissent en quelques heures. Quand une offre vous plaît, mieux vaut ne pas attendre. Les tarifs et les disponibilités peuvent changer à tout moment."],
];

const FaqList = () => (
  <Accordion type="single" collapsible className="mt-10 border-t border-navy/10">
    {FAQ.map(([q, a], i) => (
      <AccordionItem key={i} value={`q${i}`} className="border-navy/10">
        <AccordionTrigger data-testid={`faq-question-${i + 1}`} className="gap-4 py-5 text-center font-display text-base text-navy hover:no-underline sm:text-lg [&>svg]:shrink-0">
          <span className="flex-1 pl-8">{q}</span>
        </AccordionTrigger>
        <AccordionContent data-testid={`faq-answer-${i + 1}`} className="px-2 pb-6 text-center text-sm leading-relaxed text-navy/70 sm:px-8 sm:text-base">
          {a}
        </AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);

export const FaqSection = () => (
  <section id="faq" data-testid="faq-section" className="bg-ivory px-5 pb-20 sm:px-10 sm:pb-28">
    <div className="mx-auto max-w-3xl">
      <Reveal className="text-center">
        <p className="eyebrow text-gold-deep">FAQ</p>
        <h2 className="mt-4 font-display text-4xl leading-tight text-navy sm:text-5xl">Questions fréquentes</h2>
      </Reveal>
      <FaqList />
    </div>
  </section>
);

export const JoinBanner = () => (
  <section data-testid="join-banner" className="bg-navy-deep px-5 py-20 text-center sm:px-10 sm:py-24">
    <Reveal className="mx-auto max-w-2xl">
      <p className="eyebrow text-gold">Altitude Club</p>
      <h2 className="mt-4 font-display text-4xl leading-tight text-ivory sm:text-5xl">
        Aujourd'hui, <span className="text-gold-gradient">c'est votre tour.</span>
      </h2>
      <p className="mx-auto mt-5 max-w-lg text-base text-ivory/70">Pourquoi payer plus cher ? Voyagez en classe Business au bon prix.</p>
      <Link to="/inscription" data-testid="join-banner-button" className="btn-gold group mt-9 justify-center px-8 py-4 text-base">
        Essayer gratuitement
        <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
      </Link>
    </Reveal>
  </section>
);
